<div>
    <p>You are changing the formulation of the drug. Do you want to update the existing drug or create a new one?</p>
</div>

<div style="display: flex;justify-content: center;">
    <button class="save btn" (click)="save(1)" style="width: fit-content;">Update</button>
    <button class="save btn" (click)="save(2)" style="width: fit-content;">Create new</button>
</div>